import * as React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import type { IStoreDetails } from './StoreInterfaces';

interface StoreTagsProps {
  formValues: IStoreDetails;
  setFormValues: (formValues: IStoreDetails) => void;
  handleRemove: (index: number) => void;
}

const StoreTags: React.FC<StoreTagsProps> = ({
  formValues: StoreFormValues, setFormValues: setStoreFormValues, handleRemove,
}) => (
  <>
    {StoreFormValues.tags?.map((tag, tagIndex) => (
      <Grid container>
        <Grid item lg={4}>
          <Box p={2}>
            <TextField
              value={tag.key}
              id={`tag${tagIndex}-key-input`}
              required
              label="Key"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempTagValues = StoreFormValues.tags;
                tempTagValues[tagIndex].key = inputVal;
                setStoreFormValues({ ...StoreFormValues, tags: tempTagValues });
              }}
            />
          </Box>
        </Grid>
        <Grid item lg={4}>
          <Box p={2}>
            <TextField
              value={tag.value}
              id={`tag${tagIndex}-value-input`}
              required
              label="Value"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempTagValues = StoreFormValues.tags;
                tempTagValues[tagIndex].value = inputVal;
                setStoreFormValues({ ...StoreFormValues, tags: tempTagValues });
              }}
              error={tag.inherited && tag.value.length === 0}
              helperText={tag.inherited && tag.value.length === 0 ? 'Inherited tags required.' : ''}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box display="flex" p={2}>
            <FormControlLabel
              label="Inheritable"
              disabled={tag.inherited}
              control={(
                <Checkbox
                  checked={tag.inheritable}
                  color="primary"
                  size="small"
                  id={`${tagIndex}-inheritable-radio-button`}
                  onClick={() => {
                    const tempTagValues = StoreFormValues.tags;
                    tempTagValues[tagIndex].inheritable = !StoreFormValues.tags[tagIndex].inheritable;
                    setStoreFormValues({ ...StoreFormValues, tags: tempTagValues });
                  }}
                />
                )}
            />
            <Tooltip title="Remove Tag" placement="top">
              <IconButton onClick={() => { handleRemove(tagIndex); }} style={{ color: '#6CAE75', float: 'right' }} disabled={false}>
                <RemoveCircleIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    ))}
  </>
);

export default StoreTags;
